export const createTimestamp = () => Date.now();

export const createTimeStampString = () => createTimestamp().toString();
